import { StatusBar } from './StatusBar';
import { assertNever } from '@tock/shared/utils/typeUtils';
import { dashboard } from 'types';
import { useTheme } from '@emotion/react';

type NotifyStatusBarProps = {
  state: dashboard.CalendarWaitlist['state'];
};

export const NotifyStatusBar = ({ state }: NotifyStatusBarProps) => {
  const { colors } = useTheme();
  let barColor = '';

  switch (state) {
    case 'ACTIVE':
      barColor = 'var(--spec-grey)';
      break;
    case 'NOTIFIED':
      barColor = colors.bgPrimaryBase;
      break;
    case 'FULFILLED':
      barColor = colors.bgSuccessBase;
      break;
    default:
      assertNever(state);
  }

  return <StatusBar barColor={barColor} />;
};
